import * as React from 'react';
import * as ReactDOM from 'react-dom';

export interface PortalProps{
  toElement: string;
  forwardKey?: string;
  children?:any;
}
/**
 * Support rendering children into a VDOM parent
 *
 * While waiting for an official React.Portal
 * https://github.com/facebook/react/issues/10711
 */
export class Portal extends React.Component<PortalProps> {
  private el:Element;

  public componentDidMount(){
    this.el = document.getElementById(this.props.toElement);
    this.el && this.forceUpdate();
  }
  public render(){
    return this.el ? ReactDOM.createPortal(this.props.children, this.el, this.props.forwardKey) : null;
  }
}
